import { useState } from 'react';
import { usePWA } from '../../hooks/usePWA';

const DISMISS_KEY = 'pwa_internal_install_dismissed_at';
const DISMISS_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

function wasRecentlyDismissed(): boolean {
  const raw = localStorage.getItem(DISMISS_KEY);
  if (!raw) return false;
  const ts = parseInt(raw, 10);
  if (Number.isNaN(ts)) return false;
  return Date.now() - ts < DISMISS_COOLDOWN_MS;
}

export function InstallBanner() {
  const { canInstall, isInstalled, promptInstall } = usePWA();
  const [hidden, setHidden] = useState(() => wasRecentlyDismissed());

  if (isInstalled || !canInstall || hidden) return null;

  const handleInstall = async () => {
    const result = await promptInstall();
    if (result === 'dismissed') {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
      setHidden(true);
    } else if (result === 'accepted') {
      setHidden(true);
    }
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setHidden(true);
  };

  return (
    <div
      className="fixed left-4 right-4 z-40 bg-white border border-slate-200 rounded-xl shadow-lg px-4 py-3 flex items-center gap-3"
      style={{ bottom: 'calc(5.5rem + env(safe-area-inset-bottom))' }}
    >
      <div className="w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center text-xl flex-shrink-0">
        📲
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-slate-900">Instala GranArqui</p>
        <p className="text-xs text-slate-500 truncate">
          Accede más rápido desde tu pantalla de inicio
        </p>
      </div>
      <div className="flex items-center gap-1.5">
        <button
          onClick={handleInstall}
          className="px-3 py-1.5 rounded-md bg-primary text-white text-xs font-semibold"
        >
          Instalar
        </button>
        <button
          onClick={handleDismiss}
          className="text-slate-400 hover:text-slate-600 px-1"
          aria-label="Cerrar"
        >
          ✕
        </button>
      </div>
    </div>
  );
}